import { render, staticRenderFns } from "./EditorFormRow.vue?vue&type=template&id=453a9412&"
import script from "./EditorFormRow.vue?vue&type=script&lang=js&"
export * from "./EditorFormRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports